import React, { useState, useRef, useCallback, useEffect } from 'react';
import { cx } from 'linaria';
import { styled } from 'linaria/react';
import PropTypes from 'prop-types';

const MulitRangeSliderWrapper = styled('div')`
  width: 100%;
  margin-bottom: 1rem;
  position: relative;

  .slider {
    position: relative;
    width: 100%;
  }

  .slider__track,
  .slider__range {
    border-radius: 2px;
    height: 2px;
    position: absolute;
  }

  .slider__track {
    /* background-color: red; */
    width: 100%;
    z-index: 1;
  }

  .slider__range {
    /* background-color: orange; */
    z-index: 2;
  }

  /* Removing the default appearance */
  .thumb,
  .thumb::-webkit-slider-thumb {
    -webkit-appearance: none;
    -webkit-tap-highlight-color: transparent;
  }

  .thumb {
    pointer-events: none;
    position: absolute;
    height: 0;
    width: 200px;
    outline: none;

    &.mobile {
      width: 100%;
    }
  }

  .thumb--zindex-3 {
    z-index: 3;
    height: 2px;
  }

  .thumb--zindex-4 {
    z-index: 4;
    height: 2px;
  }

  /* For Chrome browsers */
  .thumb::-webkit-slider-thumb {
    background-color: black;
    border: none;
    border-radius: 50%;
    box-shadow: 0 0 1px 1px #ced4da;
    cursor: pointer;
    height: 18px;
    width: 18px;
    margin-top: 0px;
    pointer-events: all;
    position: relative;
  }

  /* For Firefox browsers */
  .thumb::-moz-range-thumb {
    background-color: blue;
    border: none;
    border-radius: 50%;
    box-shadow: 0 0 1px 1px #ced4da;
    cursor: pointer;
    height: 18px;
    width: 18px;
    margin-top: 2px;
    pointer-events: all;
    position: relative;
  }

  .slider__left-value,
  .slider__right-value {
    color: black;
    font-size: 12px;
    margin-top: 20px;
  }
`;

export const MultiRangeSlider = ({
  min,
  max,
  onChange,
  activeMin,
  activeMax,
  mobile,
}) => {
  const [minVal, setMinVal] = useState(activeMin ?? min);
  const [maxVal, setMaxVal] = useState(activeMax ?? max);
  const minValRef = useRef(null);
  const maxValRef = useRef(null);
  const range = useRef(null);

  // Convert to percentage
  const getPercent = useCallback(
    (value) => {
      Math.round(((value - min) / (max - min)) * 100);
    },
    [min, max]
  );
  // Set width of the range to decrease from the left side
  useEffect(() => {
    if (maxValRef.current) {
      const minPercent = getPercent(minVal);
      const maxPercent = getPercent(+maxValRef.current.value);

      if (range.current) {
        range.current.style.left = `${minPercent}%`;
        range.current.style.width = `${maxPercent - minPercent}%`;
      }
    }
  }, [minVal, getPercent]);

  // Set width of the range to decrease from the right side
  useEffect(() => {
    if (minValRef.current) {
      const minPercent = getPercent(+minValRef.current.value);
      const maxPercent = getPercent(maxVal);

      if (range.current) {
        range.current.style.width = `${maxPercent - minPercent}%`;
      }
    }
  }, [maxVal, getPercent]);

  // Get min and max values when their state changes
  useEffect(() => {
    onChange({ min: minVal, max: maxVal });
  }, [minVal, maxVal, onChange]);

  return (
    <MulitRangeSliderWrapper>
      <input
        type="range"
        min={min}
        max={max}
        step={'1'}
        value={minVal}
        ref={minValRef}
        onChange={(event) => {
          const value = Math.min(+event.target.value, maxVal - 1);
          setMinVal(value);
          event.target.value = value.toString();
        }}
        className={cx(
          'thumb thumb--zindex-3',
          minVal > max - 100 && 'thumb--zindex-5',
          mobile && 'mobile'
        )}
      />
      <input
        type="range"
        min={min}
        max={max}
        step={'1'}
        value={maxVal}
        ref={maxValRef}
        onChange={(event) => {
          const value = Math.max(+event.target.value, minVal + 1);
          setMaxVal(value);
          event.target.value = value.toString();
        }}
        className={cx('thumb thumb--zindex-4', mobile && 'mobile')}
      />
      <div ref={range} className="slider__range" />
      {/* <RangeValueRow>
        <div className="slider__left-value">{minVal}</div>
        <div className="slider__right-value">{maxVal}</div>
      </RangeValueRow> */}
    </MulitRangeSliderWrapper>
  );
};

MultiRangeSlider.propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};
